import { Config } from '../_config'
import { Environment } from '../_kernel/Environment'
import { Domain } from './Domain'

export class FactoryDomain {
  static create({ config }: { config: Config }) {
    return new FactoryDomain(config)
  }

  constructor(private config: Config) {}

  async domain(): Promise<Domain> {
    const isNode = Environment.create().isNode()

    return isNode
      ? (await import('./NodeDomain')).NodeDomain.create({ config: this.config })
      : (await import('./WindowDomain')).WindowDomain.create({ config: this.config })
  }
}
